import { Link } from "react-router-dom";
import { provideLocationState } from "components/utility/hoc/LocationState";

var CurrentUser = require("lib/account/CurrentUser");
var OrgTypes = require("lib/academic/OrgTypes");
var OrgActivityRouting = require("lib/routing/OrgActivityRouting");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var WidgetContainer = require("components/data/widgets/WidgetContainer.js")

require("users/admins/admin_home_page");

@provideLocationState(OrgActivityRouting.getRouteState)
class CustomAdminHomePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick(){
		LuckyOrangeClient.tagComponent("upgradeCodeTable")
	}

	renderWidgetContainer(entityType) {
		var currentUser = CurrentUser.get()
		var widgetParams = { topLevelDigest: entityType, period: WidgetConfig.PERIOD, adminID: [currentUser.id] }
		return <WidgetContainer userID={currentUser.id} widgetParams={widgetParams} />
	}

	districtAdminContent() {
		var headerText = "District Admin Dashboard";

		var setupProgressLink = (
			<span>
				<Link to={"/settings/code-table"} onClick={this.onClick}>
					View your district's setup progress
				</Link>
			</span>
		)

		var widgetContainer = this.renderWidgetContainer(WidgetConfig.DISTRICT_ORG_ENTITY_TYPE)
		
		return { headerText, setupProgressLink, widgetContainer }
	}

	schoolAdminContent() {
		var headerText = "School Admin Dashboard";

		var setupProgressLink = (
			<span>
				<Link to={"/settings/code-table"} onClick={this.onClick}>
					View your school's setup progress
				</Link>
			</span>
		)

		var widgetContainer = this.renderWidgetContainer(WidgetConfig.SCHOOL_ORG_ENTITY_TYPE)

		return { headerText, setupProgressLink, widgetContainer }
	}

	render () {
		if (this.props.adminOrgLevel === OrgTypes.DISTRICT_ORG) {
			var { headerText, setupProgressLink, widgetContainer } = this.districtAdminContent()
		} else {
			var { headerText, setupProgressLink, widgetContainer } = this.schoolAdminContent()
		}

		return (
			<div className="container adminHomePage">
				<header className="pageHeader hideOnPrint">
					<h1>{ headerText }</h1>
					<div className="setupLink"> {setupProgressLink}</div>
				</header>
				{ widgetContainer }
			</div>
		)
	}
};

CustomAdminHomePage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object.isRequired,
	adminOrgLevel: PropTypes.string.isRequired
});

module.exports = CustomAdminHomePage;



// WEBPACK FOOTER //
// ./modules/components/users/admins/CustomAdminHomePage.js